var $ = require('jquery');
var user = require('./user.js');
var head = {
    init: function(){
         if (location.host === 'vip.xunlei.com') {
            head.vip()
         }else if(location.host === 'act.vip.xunlei.com'){
            head.knAndAct()
         }else if (location.host === 'act.jsq.xunlei.com'){
            head.JSQ()
         }
    },
    vip: function(){
        var loginTpl = $('#loginAfter_tpl').html();
        $('#header-unlogin').hide();
        var data = {
            'avatar': user.avatar(),
            'icon': user.vipIcon(),
            'vipName': user.vipName(),
            'iconUrl': user.iconUrl(),
            'nameClass': user.isVip() ? '#C80000' : '#383838',
            'userName': user.nickname(),
            'expireTip': getVipExpireTimeTip()
        }
        $('#header-login').html((_.template(loginTpl))(data)).show();
        $('.pay-vip').html(user.payText());

        //获取会员过期时间提示
        function getVipExpireTimeTip() {
            var expireDays = Math.abs(getCookie('vip_expiredays'));
            var tipStr;
            if (user.isStopVip()) {
                return '您的会员已暂停';
            }

            if (user.isMobileVip()) {
                return '您当前是手机包月会员';
            }

            if (user.isOldvip()) {
                if (expireDays < 30) {
                    tipStr = '过期会员成长值每日降10点';
                } else {
                    tipStr = '您的会员已过期';
                }
            } else if (user.isVip()) {
                if (expireDays == 0) {
                    tipStr = '你的会员今日到期，记得续费哦~';
                } else if (expireDays < 15) {
                    tipStr = '你的会员将于' + expireDays + '天后到期';
                } else {
                    tipStr = '会员有效期' + user.expiredate();
                }
            } else {
                tipStr = '点亮会员，尊享30多项特权';
            }
            return tipStr;

        }
    },
    knAndAct: function(){
        $('#header-unlogin').hide();
        var head = $('#header-login').show();
        $('#vip-icon').removeClass().addClass(user.vipIcon());
        head.find('em').find('a').eq(0).removeClass().addClass(user.isVip() ? 'username clr_red' : 'username').html('hi,' + user.nickname());
        head.find('img').attr('src', 'http://img.ucenter.xunlei.com/usrimg/' + getCookie('userid') + '/50x50');
        //兼容快鸟
        $('.j_header_userName').html(user.nickname());
        var timer;
        $('#header-login').hover(function(event) {
            timer && clearTimeout(timer);
            $(this).find('em.p_selfcon').show();
            return false;
        }, function(event) {
            timer = setTimeout(function() {
                $('em.p_selfcon').hide();
            }, 300)
        })
    },
    JSQ: function(){
         //console.log('initJSQ')
        var _div = $("#div_header"),
            _span = $("#span_userinfo"),
            nickname = user.nickname() , //昵称
            userid = getCookie("userid"),
            userno = user.xlUsername(),
            jsq_growvalue = getCookie("jsq_growvalue") ? getCookie("jsq_growvalue") : 0,
            jsq_expiredate = getCookie("jsq_expiredate"),
            jsq_level = getCookie("jsq_level"),
            jsq_paytype = getCookie("jsq_paytype"),
            jsq_type = getCookie("jsq_type") ? getCookie("jsq_type") : 0,
            jsq_score = getCookie("jsq_score") ? getCookie("jsq_score") : 0,
            jsq_expiretype = getCookie("jsq_expiretype"),
            jsq_trialvip = getCookie("jsq_trialvip") ? getCookie("jsq_trialvip") : 0,
            jsq_trialexpire = getCookie("jsq_trialexpire") ? getCookie("jsq_trialexpire") : 0;
            // console.log(jsq_trialvip)
        function _init_info() {
            _div.find(".unlogin").hide(); //隐藏登录按钮
            _div.find(".logined").show(); //展示用户信息
            _div.find(".userinfo").hover(
                function() {
                    try {
                        clearTimeout(accountHoverTimer)
                    } catch (e) {};
                    _div.find(".infopop").show();
                    $(this).addClass('userinfo_hover');
                },
                function() {
                    $(this).removeClass('userinfo_hover');
                    accountHoverTimer = setTimeout(function() {
                        _div.find(".infopop").hide();
                    }, 50);
                });
        }

        function _isyear() {
            //年会员
            if (jsq_paytype == 5 || jsq_paytype == 105) {
                return true;
            } else {
                return false;
            }
        }


        function _init_pop() {
            var _grow, _nickname, _isyear, _tmp, _timeup = '',
                _icon;
            var _top = _div.find('.popcont .top');
            var _btm = _div.find('.popcont .btm');
            var _headimg = '<a href="http://dynamic.i.xunlei.com/user" target="_blank" title="" class="face spr_head"><img src="http://img.ucenter.xunlei.com/usrimg/' + userid + '/50x50" alt="" /></a>';
            if (nickname.length > 5) {
                nickname = nickname.substring(0, 5) + '...';
            }
            _nickname = jsq_trialvip == 1 || jsq_type > 0 ? '<b >' + nickname + '</b>' : nickname;

            var _nickinfo = '<p>亲爱的' + _nickname + '</p>';

            if (jsq_type > 0) {
                //会员
                if (jsq_type == 1) {
                    //高级会员
                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl slv_icon slv' + jsq_level + '"></a></p>';
                    _icon = 'degree_icon svip' + jsq_level + ' fl';
                } else {
                    //普通会员
                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl lv_icon lv' + jsq_level + '"></a></p>';
                    _icon = "degree_icon vip" + jsq_level + " fl";
                }
                _timeup += '<p class="time"><a href="http://vip.xunlei.com/vip_service/orderlist.html" target="_blank">' + jsq_expiredate + '到期</a></p>';
            } else {
                if (jsq_trialvip == 1) {
                    //体验会员
                    jsq_trialexpire = jsq_trialexpire.split(" ");
                    _timeup += '<p class="time"><a href="http://vip.xunlei.com/vip_service/orderlist.html" target="_blank">' + jsq_trialexpire[0] + '到期</a></p>';
                    $("#trialvip_icon").show();
                }

                //过期或非会员
                if (jsq_expiretype == 1) {
                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl slvhui_icon slv' + jsq_level + '"></a></p>';
                    _icon = 'degreehui_icon svip' + jsq_level + ' fl';
                } else {
                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl lvhui_icon lv' + jsq_level + '"></a></p>';
                    _icon = 'degreeviphui_icon viphui' + jsq_level + ' fl';
                }
            }

            _tmp = _headimg + _nickinfo + _grow + _timeup;
            _top.html(_tmp);
            _span.removeClass().addClass(_icon);

            _div.find(".username").html(_nickname);
                        // alert(_nickname)
            $("#first_score").html(jsq_score);
            $("#first_grown").html(jsq_growvalue);
        }
         function _initDomInfo(){
              $('#act_nickname,.act_nickname,[name=act_nickname]').text(vipUser.nickname());
              $('#act_userid,.act_userid,[name=act_userid]').text(vipUtils.getCookie('userid'));
              if(window.ACTCONFIG && window.ACTCONFIG.open_vip_link)
              $('#header_open_vip_link').attr('href', window.ACTCONFIG.open_vip_link+'?referfrom='+referfrom);
              $('.unlogin').hide();
              $('.logined').show();
            }


        _init_info();
        _init_pop();
        _initDomInfo();
    }
}

module.exports = head



//////////////////
// WEBPACK FOOTER
// ./src/common/head.js
// module id = 11
// module chunks = 0